import { useTranslation } from 'next-i18next';
import { Slot } from '../../../../../../../interfaces/interfaces';
import { fetchAndSetFavoriteSlots } from '../../../../../../../reduxToolkit/slices/commonSlice';
import { useSelector, useDispatch } from '../../../../../../../reduxToolkit/typedRedux';
import { followSlot, unfollowSlot } from '../../../../../../../services/services';
import VyTooltip from '../../../../../../common/VyTooltip';
import { FavoriteStarIcon } from '../../../FavoriteIcon';
import { PresentationBookingButton } from '../presentationTicket/PresentationBookingButton';
import { PresentationJoinButton } from '../presentationTicket/PresentationJoinButton';

const PublicPresentationRightContent = ({ slot, joinRoom, showStartEndTime }: { slot: Slot; joinRoom?: () => void; showStartEndTime?: boolean }) => {
  const event = useSelector((state) => state.common.event);
  const user = useSelector((state) => state.common.user);
  const favoriteSlots = useSelector((state) => state.common.favoriteSlots);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  function _followSlot() {
    event &&
      followSlot(slot._id, event?._id).then(() => {
        dispatch(fetchAndSetFavoriteSlots(event._id));
      });
  }

  function _unfollowSlot() {
    event &&
      unfollowSlot(slot._id, event?._id).then(() => {
        dispatch(fetchAndSetFavoriteSlots(event._id));
      });
  }

  const isSlotFavorited = !!favoriteSlots?.find((favorite) => favorite.slot._id === slot._id);

  return (
    <>
      <div className="flex absolute top-0 right-0 bottom-0 left-0 flex-col justify-between items-end p-4 max-h-full">
        <div className="flex flex-col items-end space-y-6">
          {user && event?.settings?.enablePresentationFavorite && (
            <VyTooltip title={t('event:add-to-my-agenda')}>
              <div
                className="cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!isSlotFavorited) {
                    _followSlot();
                  } else {
                    _unfollowSlot();
                  }
                }}>
                <FavoriteStarIcon isActive={isSlotFavorited} />
              </div>
            </VyTooltip>
          )}
          <div onClick={(e) => e.stopPropagation()}>
            <PresentationBookingButton slot={slot} />
          </div>

          <div className="live" style={{ visibility: status === 'live' ? 'initial' : 'hidden' }} />
        </div>
        <PresentationJoinButton slot={slot} onClick={joinRoom} />
      </div>
    </>
  );
};

export default PublicPresentationRightContent;
